var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg20Upload1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9343_69566)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.59308 0.959106C7.82292 0.746948 8.17718 0.746948 8.40702 0.959106L11.007 3.35911C11.2505 3.58387 11.2657 3.96346 11.0409 4.20696C10.8162 4.45045 10.4366 4.46563 10.1931 4.24087L8.60005 2.77038V9.79999C8.60005 10.1314 8.33142 10.4 8.00005 10.4C7.66868 10.4 7.40005 10.1314 7.40005 9.79999V2.77038L5.80702 4.24087C5.56352 4.46563 5.18393 4.45045 4.95917 4.20696C4.7344 3.96346 4.74959 3.58387 4.99308 3.35911L7.59308 0.959106ZM1.40005 10.4C1.73142 10.4 2.00005 10.6686 2.00005 11V13C2.00005 13.5523 2.44776 14 3.00005 14H13C13.5523 14 14 13.5523 14 13V11C14 10.6686 14.2687 10.4 14.6 10.4C14.9314 10.4 15.2 10.6686 15.2 11V13C15.2 14.215 14.2151 15.2 13 15.2H3.00005C1.78502 15.2 0.800049 14.215 0.800049 13V11C0.800049 10.6686 1.06868 10.4 1.40005 10.4Z",
    fill: "#0EA374"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9343_69566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg20Upload1);
export default __webpack_public_path__ + "static/media/20-upload-1.97999bc84a817de8b8ceb78e1900cc4a.svg";
export { ForwardRef as ReactComponent };